export default __webpack_public_path__ + "img/jtc/jtc3_1500.jpg";